import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
import { getUser } from "../../../utils/commonfunction";

const commonPath = "common"
const path = "advertiser/auth"
const options = {role: ROLE.ADVERTISER};

export const login = async (values) => {
    return await axiosInstance().post(`${path}/login`, values);
}

export const signup = async (values) => {
  return await axiosInstance().post(`${path}/sign-up`, values);
}

export const completeBusinessProfile = async (values) => {
  const user = getUser(ROLE.USER);
  const opt = user && user.token ? { role: ROLE.USER } : { role: ROLE.ADVERTISER };
  return await axiosInstance(opt).patch(`${path}/complete-business-profile`, values);
}

export const updateKYC = async (values) => {
  const user = getUser(ROLE.USER);
  const opt = user && user.token ? { role: ROLE.USER } : { role: ROLE.ADVERTISER };
  return await axiosInstance(opt).patch(`${path}/complete-kyc`, values);
}

export const forgetPassword = async (values) => {
    return await axiosInstance().patch(`${path}/forgot-password`, values);
}

export const resendOTP = async (values) => {
    return await axiosInstance().patch(`${path}/resend-otp`, values);
}

export const otpVerification = async (values) => {
    return await axiosInstance().patch(`${path}/verify-otp`, values);
}

export const resendEmailAndPhoneOtp = async (values) => {
  return await axiosInstance().patch(`${path}/resend-email-phone-otp`, values);
}

export const verifyEmailAndPhoneOTP = async (values) => {
  return await axiosInstance().patch(`${path}/verify-email-phone-otp`, values);
}

export const googleLogin = async (values) => {
  return await axiosInstance().post(`${path}/google-login`, values);
}

export const appleLogin = async (values) => {
  return await axiosInstance().post(`${path}/apple-login`, values);
}


export const VerifyResetToken = async (reset_token) => {
  return await axiosInstance().get(`${commonPath}/verify-reset-token?reset_token=${reset_token}`);
}
export const ResetPassword = async (values) => {
  return await axiosInstance().patch(`${path}/reset-password`, values);
}





